// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"ranking_errorMessage__23q3i"};